export const paymentMethods  = (classes) => `
<div class="row justify-content-center ml-0 mr-0 ${classes ? classes : ''}">
<!--    <div class="tourTicketPaymentIconItem">-->
<!--        <img class="tourTicketPaymentIcon" src="/assets/images/payment/twint.png" alt="twint">-->
<!--    </div>-->
<!--    <div class="tourTicketPaymentIconItem">-->
<!--        <img class="tourTicketPaymentIcon" src="/assets/images/payment/applepay.png" alt="apple pay">-->
<!--    </div>-->
    <div class="tourTicketPaymentIconItem">
        <img class="tourTicketPaymentIcon" src="/assets/svg_icons/visa-pay-icon.svg" alt="Visa">
    </div>
    <div class="tourTicketPaymentIconItem">
        <img class="tourTicketPaymentIcon" src="/assets/images/payment/mastercard.png" alt="MasterCard">
    </div>
    <div class="tourTicketPaymentIconItem">
        <img class="tourTicketPaymentIcon" src="/assets/payment/american.png" alt="American Express">
    </div>
<!--    <div class="tourTicketPaymentIconItem">-->
<!--        <img class="tourTicketPaymentIcon" src="/assets/images/payment/discover.png" alt="Discover">-->
<!--    </div>-->
    <div class="tourTicketPaymentIconItem">
        <img class="tourTicketPaymentIcon" src="/assets/images/payment/dinersclub.png" alt="Diners">
    </div>
<!--    <div class="tourTicketPaymentIconItem">-->
<!--        <img class="tourTicketPaymentIcon" src="/assets/images/payment/jcb.png" alt="Jcb">-->
<!--    </div>-->
</div>

`;
